<!--eslint-disable max-lines-->
<template>
  <div>
    <b-card>
      <b-card-header class="cardHeader"
        >{{ $t("ui.avalanche") }}
      </b-card-header>
      <Map v-bind:title="$t('avalanche.label.location')" />
      <Date v-bind:dateLabel="$t('avalanche.label.triggerDate')" />
      <Document v-bind:commentLabel="$t('avalanche.label.comment')" />
      <div>
        <b-row cols="1" cols-sm="1" cols-md="2" class="inputFormRow">
          <b-col>
            <label for="avalancheSize"
              >{{ $t("avalanche.label.avalancheSize") }}
              <a
                :href="
                  'https://www.slf.ch' + $t('avalanche.infoLink.avalancheSize')
                "
                target="_blank"
                ><i class="fas fa-info-circle icon"
              /></a>
            </label>
            <b-form-select
              id="avalancheSize"
              v-model="selectedAvalancheSize"
              :options="avalancheSize"
            />
          </b-col>
          <b-col>
            <label for="avalancheType"
              >{{ $t("avalanche.label.avalancheType") }}
              <a
                :href="
                  'https://www.slf.ch' + $t('avalanche.infoLink.avalancheType')
                "
                target="_blank"
                ><i class="fas fa-info-circle icon"
              /></a>
            </label>
            <b-form-select
              id="avalancheType"
              v-model="selectedAvalancheType"
              :options="avalancheType"
            />
          </b-col>
          <b-col>
            <label for="avalancheMoisture"
              >{{ $t("avalanche.label.avalancheMoisture") }}
            </label>
            <b-form-select
              id="avalancheMoisture"
              v-model="selectedAvalancheMoisture"
              :options="avalancheMoisture"
            />
          </b-col>
          <b-col>
            <label for="triggerType"
              >{{ $t("avalanche.label.triggerType") }}
            </label>
            <b-form-select
              id="triggerType"
              v-model="selectedTriggerType"
              :options="triggerType"
            />
          </b-col>
        </b-row>
        <div style="padding-top: 40px; text-align: left">
          <b-row>
            <b-col>
              <label class="checkboxLabel" for="triggerRemote">
                {{ $t("avalanche.label.triggerRemote") }}
              </label>
              <div class="checkboxDivider" />
              <b-button
                id="triggerRemote"
                @click="
                  triggerRemote === true
                    ? (triggerRemote = null)
                    : (triggerRemote = true)
                "
                :variant="triggerRemote ? '' : 'outline-secondary'"
                size="sm"
              >
                {{ $t("ui.yes") }}
              </b-button>
              <b-button
                id="noTriggerRemote"
                @click="
                  triggerRemote === false
                    ? (triggerRemote = null)
                    : (triggerRemote = false)
                "
                :variant="triggerRemote === false ? '' : 'outline-secondary'"
                size="sm"
              >
                {{ $t("ui.no") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="checkboxLabel" for="materialDamageExists">
                {{ $t("avalanche.label.materialDamageExists") }}
              </label>
              <div class="checkboxDivider" />
              <b-button
                id="materialDamageExists"
                @click="
                  materialDamageExists === true
                    ? (materialDamageExists = null)
                    : (materialDamageExists = true)
                "
                :variant="materialDamageExists ? '' : 'outline-secondary'"
                size="sm"
              >
                {{ $t("ui.yes") }}
              </b-button>
              <b-button
                id="noMaterialDamageExists"
                @click="
                  materialDamageExists === false
                    ? (materialDamageExists = null)
                    : (materialDamageExists = false)
                "
                :variant="
                  materialDamageExists === false ? '' : 'outline-secondary'
                "
                size="sm"
              >
                {{ $t("ui.no") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row cols-sm="1" cols-md="2">
            <b-col sm>
              <label class="checkboxLabel" for="personDamageExists">
                {{ $t("avalanche.label.personDamageExists") }}
              </label>
              <div class="checkboxDivider" />
              <b-button
                id="personDamageExists"
                @click="
                  personDamageExists === true
                    ? (personDamageExists = null)
                    : (personDamageExists = true)
                "
                :variant="personDamageExists ? '' : 'outline-secondary'"
                size="sm"
              >
                {{ $t("ui.yes") }}
              </b-button>
              <b-button
                id="noPersonDamageExists"
                @click="
                  personDamageExists === false
                    ? (personDamageExists = null)
                    : (personDamageExists = false)
                "
                :variant="
                  personDamageExists === false ? '' : 'outline-secondary'
                "
                size="sm"
              >
                {{ $t("ui.no") }}
              </b-button>
            </b-col>
            <b-col sm>
              <label v-if="personDamageExists" for="addVictim">
                {{ $t("avalanche.label.addVictim") + ":" }}
              </label>
              <div class="personDivider" />
              <b-button
                id="addVictim"
                v-if="personDamageExists"
                @click="showVictim = true"
                size="sm"
              >
                <i class="far fa-plus-square fa-2x"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <div v-if="personDamageExists">
          <b-modal
            size="sm"
            hide-footer
            v-model="showVictim"
            :title="$t('avalanche.label.person')"
            no-close-on-backdrop
          >
            <Avalanche-add-victim @victimAdded="victimAdded">
            </Avalanche-add-victim>
          </b-modal>
          <AvalancheVictimTable
            @removeVictim="removeVictim"
            v-if="victims.length > 0"
            :victims="victims"
          />
        </div>
      </div>
      <div>
        <b-button
          class="mapButton"
          type="submit"
          :variant="isValid ? 'outline-success' : 'outline-danger'"
          :disabled="!isValid"
        >
          {{ $t("ui.sendObservation") }}
        </b-button>
        <div class="divider" />
        <b-button @click="cancel" class="mapButton" variant="outline-danger">
          {{ $t("ui.cancel") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import Document from "../common/Document.vue";
import Date from "../common/Date.vue";
import Map from "../common/Map.vue";
import AvalancheAddVictim from "./AvalancheAddVictim.vue";
import AvalancheVictimTable from "./AvalancheVictimTable.vue";
import store from "@/store/store.js";
import { i18nMixin } from "@/I18N";

export default {
  name: "Avalanche",
  components: {
    Document,
    Map,
    Date,
    AvalancheAddVictim,
    AvalancheVictimTable,
  },
  data() {
    return {
      showVictim: false,
    };
  },
  mixins: [i18nMixin],
  computed: {
    avalancheSize() {
      return this.options("avalanche", "avalancheSize");
    },
    avalancheMoisture() {
      return this.options("avalanche", "avalancheMoisture");
    },
    avalancheType() {
      return this.options("avalanche", "avalancheType");
    },
    triggerType() {
      return this.options("avalanche", "triggerType");
    },
    selectedAvalancheSize: {
      get() {
        return store.AvalancheData.getAvalancheSize();
      },
      set(avalancheSize) {
        store.AvalancheData.setAvalancheSize(avalancheSize);
      },
    },
    selectedAvalancheType: {
      get() {
        return store.AvalancheData.getAvalancheType();
      },
      set(avalancheType) {
        store.AvalancheData.setAvalancheType(avalancheType);
      },
    },
    selectedTriggerType: {
      get() {
        return store.AvalancheData.getTriggerType();
      },
      set(triggerType) {
        store.AvalancheData.setTriggerType(triggerType);
      },
    },
    selectedAvalancheMoisture: {
      get() {
        return store.AvalancheData.getAvalancheMoisture();
      },
      set(avalancheMoisture) {
        store.AvalancheData.setAvalancheMoisture(avalancheMoisture);
      },
    },
    personDamageExists: {
      get() {
        return store.AvalancheData.getPersonDamageExists();
      },
      set(personDamageExists) {
        store.AvalancheData.setPersonDamageExists(personDamageExists);
        if (!personDamageExists) {
          store.AvalancheData.clearVictims();
        }
      },
    },
    materialDamageExists: {
      get() {
        return store.AvalancheData.getMaterialDamageExists();
      },
      set(materialDamageExists) {
        store.AvalancheData.setMaterialDamageExists(materialDamageExists);
      },
    },
    triggerRemote: {
      get() {
        return store.AvalancheData.getTriggerRemote();
      },
      set(triggerRemote) {
        store.AvalancheData.setTriggerRemote(triggerRemote);
      },
    },
    victims: {
      get() {
        return store.AvalancheData.getVictims();
      },
    },
    isValid() {
      return store.isValid();
    },
  },
  methods: {
    victimAdded() {
      this.showVictim = false;
    },
    removeVictim(index) {
      store.AvalancheData.removeVictim(index);
    },
    cancel() {
      store.setCancelAlert(true);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkboxLabel {
  font-size: large;
  width: 150px;
}
.checkboxDivider {
  width: 180px;
  height: auto;
  display: inline-block;
}
.personDivider {
  width: 125px;
  height: auto;
  display: inline-block;
}
</style>
